var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPn = function SvgIconPn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.968 12H12v-.031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.261V.001h-.002C5.371 0 0 5.372 0 12h6.26V8.474L9.787 12h2.182l.032-.032V9.787L8.474 6.26z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.565A12.06 12.06 0 0 0 1.565 6.07V12h3.13V4.695H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.525 7.738 6.26H6.262L12 12.001z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ACABB1",
    d: "m18.783 7.304-1.565.522-1.565-.522-.522-1.305.522-1.304h3.13L18.261 6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M13.565 7.304v5.74c0 2.795 3.653 3.651 3.653 3.651s3.652-.856 3.652-3.652V7.304z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M13.895 14.402c.897 1.724 3.323 2.293 3.323 2.293s2.425-.57 3.323-2.293L17.218 8.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "m20.87 12.985-3.652-5.681-3.653 5.681v.058c0 .518.126.968.33 1.36l3.323-5.17 3.323 5.17c.203-.392.329-.843.329-1.36z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconPn;